/**
 * Sanitize a user / agent / enrichment-supplied URL before using it as an
 * `<a href>`. React does NOT sanitize href, so a stored `javascript:` / `data:`
 * / `vbscript:` URL would execute arbitrary JS in the victim's authenticated
 * session on click (stored XSS). Contact `linkedinUrl` and social URLs are now
 * agent-writable (and arrive via sync/import/enrichment), so every href built
 * from such a value MUST go through this helper. (#security-review)
 *
 * Policy: allow only `http(s)` / `mailto` with an explicit scheme; https-prefix a
 * scheme-less host (bare `example.com/x` or scheme-relative `//host`); return
 * `null` for anything else so the caller can drop the link entirely.
 */
export function safeExternalHref(raw: string | null | undefined): string | null {
  if (!raw || typeof raw !== 'string') return null;
  const v = raw.trim();
  if (!v) return null;
  const schemeMatch = /^([a-z][a-z0-9+.-]*):/i.exec(v);
  if (schemeMatch) {
    const scheme = schemeMatch[1].toLowerCase();
    return scheme === 'http' || scheme === 'https' || scheme === 'mailto' ? v : null;
  }
  // No explicit scheme (bare host/path, or scheme-relative `//host`) → force https.
  return `https://${v.replace(/^\/+/, '')}`;
}
